/*
 * Public API Surface of announcekit-angular
 */

export * from './lib/announcekit.component';
export * from './lib/announcekit.module';
